var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.226562 16.809L7.0599 9.95315L0.210939 3.18584C-0.0703106 2.90474 -0.0703106 2.44664 0.210939 2.16554L2.15886 0.208225C2.29427 0.0728787 2.47656 0 2.66927 0C2.86198 0 3.04427 0.0780843 3.17969 0.208225L9.9974 6.95471L16.8255 0.213431C16.9609 0.0780847 17.1432 0.00520594 17.3359 0.00520594C17.5286 0.00520594 17.7109 0.0832903 17.8464 0.213431L19.7891 2.17074C20.0703 2.45185 20.0703 2.90994 19.7891 3.19105L12.9401 9.95835L19.7682 16.809C19.9036 16.9443 19.9818 17.1265 19.9818 17.3191C19.9818 17.5117 19.9089 17.6939 19.7682 17.8293L17.8203 19.7866C17.6797 19.9271 17.4974 20 17.3099 20C17.1276 20 16.9401 19.9323 16.7995 19.7866L9.9974 12.9568L3.19011 19.7814C3.04948 19.9219 2.86719 19.9948 2.67969 19.9948C2.4974 19.9948 2.3099 19.9271 2.16927 19.7814L0.221355 17.8241C0.0859375 17.6887 0.00781441 17.5065 0.00781441 17.3139C0.0130234 17.1265 0.0911465 16.9443 0.226562 16.809Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.82c87f5ca7b3218ca641598488af9284.svg";
export { ForwardRef as ReactComponent };